module.exports = __webpack_public_path__ + "static/media/branding-logo.4918e164.png";